import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background-100 px-4 text-center">
      <span className="font-heading text-8xl font-extrabold text-primary-500 md:text-[10rem]">404</span>
      <h1 className="mt-4 font-heading text-2xl font-extrabold text-foreground-950">页面走丢了</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
        你访问的页面不存在或已被移动。不如回到首页，继续探索精彩内容吧。
      </p>
      <p className="mt-2 break-all text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
        >
          <i className="ri-home-4-line text-base" aria-hidden="true"></i>
          返回首页
        </Link>
        <Link
          to="/news"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
        >
          浏览娱乐资讯
        </Link>
      </div>
    </div>
  );
}